import { render, staticRenderFns } from "./CDEK.vue?vue&type=template&id=0376a90f&scoped=true"
import script from "./CDEK.vue?vue&type=script&lang=js"
export * from "./CDEK.vue?vue&type=script&lang=js"
import style0 from "./CDEK.vue?vue&type=style&index=0&id=0376a90f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0376a90f",
  null
  
)

export default component.exports